export const BRAND = {
  name: "Axion Bots",
  tagline: "Advanced Telegram Bots & Automation",
  ownerTelegram: "https://t.me/mightyshan",
  ownerHandle: "@mightyshan",
  axionTelegram: "https://t.me/axionbots",
  axionHandle: "@axionbots",
  ownerEmail: "https://t.me/TheAxionBot",
  ownerEmailLabel: "t.me/TheAxionBot",
  flagshipBot: {
    name: "Word Grid",
    handle: "@WordGridRobot",
    link: "https://t.me/WordGridRobot",
    description:
      "A premium multiplayer word-game bot bringing addictive grid battles, leaderboards and rich engagement to Telegram groups.",
  },
};

export const MEDIA = {
  axion_logo: "/media/axion-logo.png",
  wordgrid_logo:
    "https://customer-assets.emergentagent.com/job_bot-studio-premium/artifacts/jdn2f40m_2.jpg",
  hero_dashboard:
    "https://static.prod-images.emergentagent.com/jobs/8b1c7de0-a206-413f-8c35-b60bafe005a6/images/e0cd162e07ccbedaad8a9948944a8d030d31dba44305d4d67814894a658e2278.png",
  abstract_glow:
    "https://static.prod-images.emergentagent.com/jobs/8b1c7de0-a206-413f-8c35-b60bafe005a6/images/16e08b864d8904486cc66c6f52f1e3d124cf4b566e6b79da97de8021a2b93ccb.png",
  telegram_airplane:
    "https://static.prod-images.emergentagent.com/jobs/8b1c7de0-a206-413f-8c35-b60bafe005a6/images/c6434e77422e0fff3c1a6224eae339e3ac201b9a32254f1ca2e6287b3d087d5c.png",
  abstract_network:
    "https://images.unsplash.com/photo-1644088379091-d574269d422f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxkYXJrJTIwYWJzdHJhY3QlMjB0ZWNoJTIwbmV0d29ya3xlbnwwfHx8fDE3Nzg5NjY1NTd8MA&ixlib=rb-4.1.0&q=85",
};
